export function getUrl(){

    let url = window.location.href;
    let baseUrl = "//pro.mimic.us/"; 

    if(url.indexOf("secondev")!== -1 || url.indexOf("localhost")!== -1) {
        baseUrl = "//mimicpro.secondev.com/";
    }

    return baseUrl;
}
